import { styled } from "@mui/material"

export const GradientBorder = styled("div")(() => ({
  position: "relative",
  borderRadius: 2,
  background: "transparent",
  // gradient border
  zIndex: 1,
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "inherit",
    padding: "2px", // Adjust this value to control the border width
    background:
      "linear-gradient(115.05deg, #A8BEDE -50.81%, #80AAE0 -1.53%, #3A5DAD 58.19%, #15224A 104.48%)",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    zIndex: -1,
  },
}))
